import axios from 'axios'
import { ACCOUNT_UPDATE_API, WITH_CREDENTIALS_CONFIG } from './constants'
import { Address, PhoneNumber } from 'types/CommonTypes'

interface Addresses {
  mailingAddress: Address
  homeAddress?: Address
}

export const updateAddress = (accountNumber: string, address: Addresses) =>
  axios.post(
    ACCOUNT_UPDATE_API(accountNumber),
    address,
    WITH_CREDENTIALS_CONFIG
  )

export const updateAccountEmail = (email: string, accountNumber: string) =>
  axios.post(
    ACCOUNT_UPDATE_API(accountNumber),
    { emailAddresses: [email] },
    WITH_CREDENTIALS_CONFIG
  )

export const updatePhone = (
  accountNumber: string,
  phoneNumbers: PhoneNumber[]
) =>
  axios.post(
    ACCOUNT_UPDATE_API(accountNumber),
    { phoneNumbers: phoneNumbers },
    WITH_CREDENTIALS_CONFIG
  )
